import { z } from "zod";

import { DatabaseDefaults } from "@/src/models/database-defaults";

export enum TaskStepStatus {
  ASYNC = "async",
  COMPLETED = "completed",
  FAILED = "failed",
  PAUSED = "paused",
}

export const taskStepSchema = z.object({
  taskId: z.string().uuid(),
  stepIndex: z.number().int(),
  stepKey: z.string(),
  status: z.nativeEnum(TaskStepStatus),
  output: z.record(z.unknown()).nullable(),
  remainingRetries: z.number().int().min(0),
});

export type TaskStep = z.infer<typeof taskStepSchema> & DatabaseDefaults;

export const taskStepShape: TaskStep = {
  id: "",
  taskId: "",
  stepIndex: 0,
  stepKey: "",
  status: TaskStepStatus.COMPLETED,
  output: null,
  remainingRetries: 0,
  groupId: "",
  createdAt: "",
  updatedAt: "",
  deletedAt: null,
};
